import { useQuery } from "@tanstack/react-query";
import ConfigHolder from "../../config/ConfigHolder";
import useWidgetStore from "../../store/useWidgetStore";
import { useSettings } from "../../context/SettingsContext";
export const usePrepareCart = (formContext, options) => {
    const { api_key, widget_id } = useSettings();
    const defaultOptions = Object.assign(Object.assign({}, options), { enabled: false, networkMode: "always", cacheTime: 0, staleTime: 0 });
    const { cart, setCart, booking, consumer, selectedResource, selectedCapacityGroups, getDaoAppointments, getDaoProducts } = useWidgetStore();
    const { hasResourceSelect } = useSettings();
    return useQuery(Object.assign(Object.assign({}, defaultOptions), { queryKey: ['widget-prepareCart'], queryFn: async ({ signal }) => {
            var _a, _b, _c, _d;
            let url = ConfigHolder.getApiMethodUrl(api_key, widget_id, 'prepareCart', 'checkout');
            let _consumer = {
                hash: (_a = consumer.hash) !== null && _a !== void 0 ? _a : '',
                id: (_b = consumer.id) !== null && _b !== void 0 ? _b : ''
            };
            // these are loaded using useVouchers in the summary
            let _discounts = cart.discounts;
            let _appointments = getDaoAppointments(), _products = getDaoProducts(), 
            // Only a resource the consumer actually picked (not the -1 "no preference"
            // sentinel) counts - otherwise the backend has nothing to distinguish a real
            // pick from an appointment that never showed a resource control at all, and
            // marks every resourceAssignment 'manual' instead of only the ones that are.
            hasSelectedResource = selectedResource
                ? selectedResource.filter((resourceId) => resourceId !== -1).length > 0
                : false;
            let data = {
                // each appointment's own appTypeId/resourceId/capacity, not the globally
                // selected* state - that only reflects whichever appointment is currently
                // being edited on the select view, and would collapse every other
                // appointment in the cart onto it
                appointments: _appointments.length > 0 ? _appointments.map((_appointment) => {
                    var _a, _b, _c, _d, _e;
                    return {
                        appTypeId: _appointment.appTypeId,
                        resourceId: hasSelectedResource ? _appointment.resourceId : null,
                        // Default 1, not null - the backend's price lookup for a capacity-priced
                        // apptype needs a real capacity even when no capacity control was shown
                        capacity: (_a = _appointment.capacity) !== null && _a !== void 0 ? _a : 1,
                        components: [_appointment],
                        date: (_b = _appointment.date) !== null && _b !== void 0 ? _b : _appointment.time,
                        time: _appointment.time,
                        fields: (_c = consumer.fields) !== null && _c !== void 0 ? _c : {},
                        remark: (_d = booking.remark) !== null && _d !== void 0 ? _d : ((_e = consumer.remark) !== null && _e !== void 0 ? _e : '')
                    };
                }) : [],
                products: _products,
                discounts: _discounts,
                customer: _consumer,
                remark: (_c = consumer.remark) !== null && _c !== void 0 ? _c : ''
            };
            const response = await fetch(url.href, {
                signal: signal,
                method: "POST",
                headers: {
                    'Content-Type': 'application/json', // checks this header if it's a POST, while calling the method getRestData.... That's not Restful
                    'X-OAnl-csrf-protection': 'on',
                    'accept': 'application/json+ld',
                },
                body: JSON.stringify(data)
            });
            setCart(Object.assign(Object.assign({}, cart), { secureToken: (_d = response.headers.get('x-oanl-secure-token')) !== null && _d !== void 0 ? _d : '' }));
            return response.json();
        } }));
};
